import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const VisibilityScore = ({ data, className }) => (
  <div className={cx('score-item', className)}>
    <p className="label">{data.title}</p>
    <div className="metrics">
      <div className="metrics__score">
        <h1 className="h1">{data.score}</h1>
        <div
          className="gray-semicircle"
          style={{ transform: `rotate(-${(100 - data.score) * 1.8}deg)` }}
        />
      </div>
      <div className="metrics__bar">
        <div className="metric-bar-wrapper">
          <p className="label-sm">{data.firstMetric.title}</p>
          <div className="metric-gray-bar">
            <div
              className="metric-bar"
              style={{ width: `calc((100% * ${data.firstMetric.value}) / 100)` }}
            />
          </div>
        </div>
        <div className="metric-bar-wrapper">
          <p className="label-sm">{data.secondaryMetric.title}</p>
          <div className="metric-gray-bar">
            <div
              className="metric-bar"
              style={{ width: `calc((100% * ${data.secondaryMetric.value}) / 100)` }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

VisibilityScore.propTypes = {
  data: T.object.isRequired,
  className: T.string,
};

export default VisibilityScore;
